export function createLineLayer (layerName: string, paint: any, overrides?: any) {
    return {
        id: `${layerName}`,
        source: layerName,
        type: 'line',
        interactive: true,
        layout: {
            visibility: 'none'
        },
        paint: {
            // Fill - #fbdada; Outline - #ba1c1cFill
            // "line-color": "#fb543b",
            "line-color": "#daa520",
            "line-width": 3,
            // "fill-opacity": 0.5,
            ...paint
        },
        ...overrides
    };
}
